module.exports = __webpack_public_path__ + "img/6.e12085a3.png";